<template>
  <div
    data-collapse="medium"
    data-animation="default"
    data-duration="500"
    data-easing="ease-in"
    data-easing2="ease-out"
    class="navbar w-nav"
  >
    <div class="div-block">
      <nav role="navigation" class="w-nav-menu">
        <div data-hover="1" data-delay="1" class="w-dropdown">
          <div class="dropdown-toggle w-dropdown-toggle">
            <div class="nav-link cool-link">
              {{ $t("navbar.about_madrigal") }}
            </div>
          </div>
          <nav class="dropdown-list w-dropdown-list">
            <router-link
              :to="{ name: 'mc', params: { locale: $i18n.locale } }"
              class="nav-link transp w-nav-link"
              v-on:click.native="closeMenu"
              >Marin Constantin</router-link
            >
            <router-link
              :to="{ name: 'history', params: { locale: $i18n.locale } }"
              class="nav-link transp w-nav-link"
              v-on:click.native="closeMenu"
              >{{ $t("navbar.history") }}</router-link
            >
            <router-link
              :to="{ name: 'cultural-ambassador', params: { locale: $i18n.locale } }"
              class="nav-link transp w-nav-link"
              v-on:click.native="closeMenu"
              >{{ $t("navbar.culturalAmbassador") }}</router-link
            >
            <router-link
              :to="{ name: 'management', params: { locale: $i18n.locale } }"
              class="nav-link transp w-nav-link"
              v-on:click.native="closeMenu"
              >{{ $t("navbar.management") }}</router-link
            >
            <router-link
              :to="{
                name: 'public-information',
                params: { locale: $i18n.locale }
              }"
              class="nav-link transp w-nav-link"
              v-on:click.native="closeMenu"
              >{{ $t("navbar.publicInfo") }}</router-link
            >
            <!--<router-link :to="{name: 'shop'}" class="nav-link transp w-nav-link" v-on:click.native="closeMenu">Magazin</router-link>-->
          </nav>
        </div>

        <!--<div data-hover="1" data-delay="1" class="w-dropdown">-->
        <!--<div class="dropdown-toggle w-dropdown-toggle">-->
        <!--<div class="nav-link cool-link">Evenimente</div>-->
        <!--</div>-->
        <!--<nav class="dropdown-list w-dropdown-list">-->
        <!--<router-link :to="{name: 'events', params: {type: 'news'}}" class="nav-link transp w-nav-link" v-on:click.native="closeMenu">Noutati</router-link>-->
        <!--<router-link :to="{name: 'events', params: {type:'archive'}}" class="nav-link transp w-nav-link" v-on:click.native="closeMenu">Arhiva</router-link>-->
        <!--</nav>-->
        <!--</div>-->

        <router-link
          :to="{
            name: 'events',
            params: { type: 'news', locale: $i18n.locale }
          }"
          class="nav-link cool-link w-nav-link"
          v-on:click.native="closeMenu"
          >{{ $t("navbar.events") }}</router-link
        >

        <router-link
          :to="{
              name: 'setlists',
              params: { locale: $i18n.locale }
            }"
            class="nav-link cool-link w-nav-link"
            v-on:click.native="closeMenu">{{ $t("navbar.setlists") }}
        </router-link>

        <router-link
          :to="{ name: 'media', params: { locale: $i18n.locale } }"
          class="nav-link cool-link w-nav-link"
          v-on:click.native="closeMenu"
          >{{ $t("navbar.media") }}</router-link
        >

        <router-link
          :to="{ name: 'shop', params: { locale: $i18n.locale } }"
          class="nav-link cool-link w-nav-link"
          v-on:click.native="closeMenu"
          >{{ $t("navbar.shop") }}</router-link
        >

        <router-link
          :to="{ name: 'contact', params: { locale: $i18n.locale } }"
          class="nav-link cool-link w-nav-link"
          >{{ $t("navbar.contact") }}</router-link
        >

        <div data-hover="1" data-delay="1" class="w-dropdown">
          <div class="dropdown-toggle w-dropdown-toggle">
            <div class="nav-link cool-link">
              <div class="lang-wrapper">
                <span class="lang-flag-label"
                  >{{ $t("navbar.language") }}:</span
                >
                <country-flag
                  :country="country"
                  size="small"
                  class="lang-flag"
                />
                <span class="lang-flag-display">{{ langDisplay }}</span>
              </div>
            </div>
          </div>
          <nav class="dropdown-list w-dropdown-list">
            <a
              class="nav-link transp w-nav-link flag-link"
              style="cursor: pointer"
              @click="changeLang('ro')"
              ><country-flag country="ro" size="small" /><span
                class="lang-flag-display"
                >{{ $t("navbar.language_ro") }}</span
              ></a
            >
            <a
              class="nav-link transp w-nav-link flag-link"
              style="cursor: pointer"
              @click="changeLang('en')"
              ><country-flag country="gb" size="small" /><span
                class="lang-flag-display"
                >{{ $t("navbar.language_en") }}</span
              ></a
            >
          </nav>
        </div>
      </nav>

      <router-link
        :to="{ name: 'home', params: { locale: $i18n.locale } }"
        class="w-nav-brand w--current"
        ><img :src="src" alt="" width="215"
      /></router-link>
      <div class="w-nav-button">
        <div class="w-icon-nav-menu" ref="menuButton"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  data: function() {
    return {
      src: require("../assets/images/LogoM.png")
    };
  },
  methods: {
    closeMenu: function() {
      this.$refs.menuButton.click();
    },
    changeLang: function(lang) {
      this.$i18n.locale = lang;
      this.closeMenu();
      this.$router.replace({ ...this.$route, params: { locale: lang } });
    }
  },
  computed: {
    lang: function() {
      return this.$i18n.locale;
    },
    country: function() {
      switch (this.$i18n.locale) {
        case "en":
          return "gb";
        default:
          return this.$i18n.locale;
      }
    },
    langDisplay: function() {
      switch (this.$i18n.locale) {
        case "ro":
          return this.$t("navbar.language_ro");
        case "en":
          return this.$t("navbar.language_en");
        default:
          return "";
      }
    }
  }
};
</script>

<style scoped>
.navbar {
  padding-top: 25px;
  padding-bottom: 103px;
  background-color: transparent;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(33%, rgba(9, 25, 37, 0.69)),
    to(hsla(0, 0%, 100%, 0))
  );
  background-image: linear-gradient(
    180deg,
    rgba(9, 25, 37, 0.69) 33%,
    hsla(0, 0%, 100%, 0)
  );
  position: absolute;
  width: 100%;
}

.nav-link {
  display: inline-block;
  font-family: Roboto, sans-serif;
  color: #fff;
  font-size: 0.9em;
  text-decoration: none;
  text-transform: uppercase;
}

.nav-link.transp {
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  color: #000;
}

.nav-link.transp:hover {
  background-color: #2d4557;
  color: #fff;
}

.div-block {
  display: block;
  max-width: 1140px;
  margin-right: auto;
  margin-left: auto;
}

.dropdown-list {
  background-color: #b89090;
}

.dropdown-list.w--open {
  left: 17px;
  border-radius: 3px;
  background-color: #fff;
}
.lang-wrapper {
  display: flex;
}
.lang-flag-label {
  margin-right: 0.5em;
}
.lang-flag-display {
  margin-left: 0.5em;
}
.flag-link {
  display: flex;
}
</style>
